import { render } from "./analysis2.vue?vue&type=template&id=226e006f&scoped=true"
import script from "./analysis2.vue?vue&type=script&lang=js"
export * from "./analysis2.vue?vue&type=script&lang=js"

import "./analysis2.vue?vue&type=style&index=0&id=226e006f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226e006f"]])

export default __exports__